import { __awaiter } from "tslib";
import Vue from 'vue';
import selectHandlersMixin from './_selectHandlersMixin';
import draggable from 'vuedraggable';
import Swiper from '@/components/global/Swiper/Swiper.vue';
import swiperSlide from '@/components/global/Swiper/SwiperSlide';
import mobLimitBidsTableDetailItem from './daughterComponents/_mobLimitBidsTableDetailItem';
import { mapGetters } from 'vuex';
import { ItemClosingStatusEnum, ItemCloseRecordSource } from '@/store/modules/mainPageModules/utils/itemClose';
import _ from 'lodash';
var Sections;
(function (Sections) {
    Sections["spot"] = "\u0421\u043F\u043E\u0442";
    Sections["futures"] = "\u0424\u044C\u044E\u0447\u0435\u0440\u0441";
})(Sections || (Sections = {}));
var ServerSections;
(function (ServerSections) {
    ServerSections["spot"] = "spot";
    ServerSections["futures"] = "futures";
})(ServerSections || (ServerSections = {}));
let tableHeadItems = [
    {
        id: 1,
        switched: true,
        text: 'mainPage.tables.tableHeaders.ticker',
        align: 'start',
        sortable: true,
        value: 'ticker',
        width: 158,
        priority: 1
    },
    {
        id: 2,
        switched: true,
        text: 'mainPage.tables.tableHeaders.executionPrice',
        align: 'end',
        sortable: true,
        value: 'positionPrice',
        width: 158,
        priority: 1
    },
    {
        id: 3,
        switched: true,
        text: 'mainPage.tables.tableHeaders.volume',
        align: 'start',
        sortable: true,
        value: 'volume',
        width: 154,
        priority: 2
    },
    {
        id: 4,
        switched: true,
        text: 'mainPage.tables.tableHeaders.orderType',
        align: 'start',
        sortable: true,
        value: 'direction',
        width: 158,
        priority: 3
    },
    {
        id: 5,
        switched: true,
        text: 'mainPage.tables.tableHeaders.section',
        align: 'start',
        sortable: true,
        value: 'section',
        width: 158,
        priority: 2
    },
    {
        id: 6,
        switched: true,
        text: 'mainPage.tables.tableHeaders.actions',
        align: 'center',
        sortable: true,
        value: 'actions',
        priority: 1
    }
];
export default Vue.extend({
    props: {
        isMain: {
            type: Boolean,
            required: true,
            default: false
        }
    },
    data: () => ({
        dragOptions: {
            animation: 200,
            group: 'description',
            disabled: false,
            ghostClass: 'ghost'
        },
        showMenu: false,
        secondaryContextMenu: false,
        headersBuffer: tableHeadItems,
        menuItems: tableHeadItems,
        menuPositionX: 0,
        menuPositionY: 0,
        sorting: '',
        isDescSort: false,
        scrolledDown: false,
        closeAwait: false,
        mobTableTypes: ['mainPage.tables.common.brief', 'mainPage.tables.common.detailed'],
        mobTableType: 0,
        activeSlideDetailsIndex: 0,
        detailsSliderHasInited: false,
        detailsSliderKey: ''
    }),
    computed: Object.assign(Object.assign({}, mapGetters('mainPageModules', ['getLimitsBidsTable'])), { reducedItemsByName() {
            return Object.keys(this.getLimitsBidsTable.items.reduce((acc, curr) => {
                acc[curr.ticker] = '';
                return acc;
            }, {}));
        },
        reducedItemsByQuantity() {
            const vm = this;
            if (vm.detailsSliderKey) {
                return vm.getLimitsBidsTable.items.reduce((acc, curr, index) => {
                    if (curr.ticker === vm.detailsSliderKey) {
                        acc.push({
                            positionPrice: curr.positionPrice,
                            index
                        });
                    }
                    return acc;
                }, []);
            }
            else
                return [];
        },
        headersByPriority() {
            const vm = this;
            let currPriority = 3;
            if (vm.$root.windowWidth <= 768 && vm.$root.windowWidth >= 516)
                currPriority = 2;
            if (vm.$root.windowWidth < 516)
                currPriority = 1;
            return vm.headersBuffer.reduce((acc, curr) => {
                if (curr.priority <= currPriority) {
                    if (currPriority === 1) {
                        if (curr.width === 158)
                            curr.width = 130;
                        if (curr.width === 28)
                            curr.width = 37;
                    }
                    else if (currPriority === 2) {
                        if (curr.width === 148)
                            curr.width = 120;
                        if (curr.width === 154)
                            curr.width = 84;
                        if (curr.width === 28)
                            curr.width = 44;
                    }
                    acc.push(curr);
                }
                return acc;
            }, []);
        },
        selectedItems() {
            return this.getLimitsBidsTable.items.filter((item) => item.selected);
        } }),
    watch: {
        detailsSliderHasInited(v) {
            const vm = this;
            if (v) {
                if (!vm.detailsSliderKey) {
                    if (vm.reducedItemsByName.length) {
                        vm.detailsSliderKey = vm.reducedItemsByName[0];
                    }
                }
            }
        },
        reducedItemsByName(v) {
            const vm = this;
            if (v.length === 1) {
                vm.detailsSliderKey = v[0];
            }
        },
        reducedItemsByQuantity(v) {
            if (v.length)
                this.activeSlideDetailsIndex = v[0].index;
        },
        getLimitsBidsTable: {
            handler(v) {
                if (!v.items.length)
                    this.detailsSliderKey = '';
            },
            deep: true
        },
        headersBuffer(v) {
            localStorage.setItem('mainPageLimitBidsHeaders', JSON.stringify(v));
        },
        menuItems: {
            handler(list) {
                const vm = this;
                list.forEach((item, index) => {
                    const currentItemIndex = vm.headersBuffer.findIndex((el) => item.id === el.id);
                    if (item.switched && currentItemIndex < 0) {
                        const actionsItemIndex = vm.headersBuffer.findIndex((item) => item.value === 'actions');
                        if (index <= actionsItemIndex) {
                            vm.headersBuffer.splice(index, 0, item);
                        }
                        else {
                            vm.headersBuffer.splice(actionsItemIndex - 1, 0, item);
                        }
                    }
                    if (!item.switched && currentItemIndex >= 0) {
                        vm.headersBuffer.splice(currentItemIndex, 1);
                    }
                });
            },
            deep: true
        }
    },
    methods: {
        getDirectionIconName(direction) {
            switch (direction) {
                case 'SL': {
                    return 'StopLoss';
                }
                case 'TP': {
                    return 'TakeProfit';
                }
                case 'Шорт': {
                    return 'Short';
                }
                case 'Лонг': {
                    return 'Long';
                }
                default: {
                    return '';
                }
            }
        },
        handleChangeScrollPosition(v) {
            this.scrolledDown = v > 0.9;
        },
        handleTheadItem(item) {
            const vm = this;
            if (vm.sorting !== item.value) {
                if (item.text) {
                    vm.sorting = item.value;
                }
                vm.isDescSort = false;
            }
            else {
                if (!vm.isDescSort) {
                    vm.isDescSort = true;
                }
                else {
                    vm.sorting = '';
                    vm.isDescSort = false;
                }
            }
        },
        moveHandler(evt) {
            return evt.to.classList.contains('bids');
        },
        showContextMenu(evt) {
            this.secondaryContextMenu = false;
            this.showMenu = false;
            this.menuPositionX = evt.clientX;
            this.menuPositionY = evt.clientY;
            this.$nextTick(() => {
                this.showMenu = true;
            });
        },
        cancelAllPositions() {
            var _a, _b, _c, _d;
            return __awaiter(this, void 0, void 0, function* () {
                this.closeAwait = true;
                const positionsToClose = this.getLimitsBidsTable.items.map((item) => {
                    return {
                        orderId: item.id,
                        source: item.section === Sections.spot ? ServerSections.spot : ServerSections.futures,
                        ticker: item.ticker
                    };
                });
                const response = yield this.services.v2.trade.cancelAllOrders(positionsToClose);
                const requested = (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.payload) === null || _b === void 0 ? void 0 : _b.requested;
                const extra = (_d = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.payload) === null || _d === void 0 ? void 0 : _d.extra;
                if (_.isArray(extra) && _.isArray(requested)) {
                    if (extra.length > 0) {
                        this.$store.dispatch('mainPageModules/reloadByError', { cause: 'extra при закрытии всех позиций' });
                    }
                    else {
                        requested.forEach((item) => {
                            if (item.status === ItemClosingStatusEnum.unhandledError) {
                                return;
                            }
                            this.$store.dispatch('mainPageModules/setOrderClose', { by: ItemCloseRecordSource.wl, id: item.id });
                        });
                    }
                    this.$store.dispatch('alertsBus/openAlert', {
                        title: this.$t('mainPage.alerts.titles.success'),
                        type: 'success',
                        autoDelete: true,
                        content: this.$t('mainPage.alerts.content.allLimitsReset')
                    });
                }
                else {
                    this.$store.dispatch('alertsBus/openAlert', {
                        title: this.$t('mainPage.alerts.titles.error'),
                        type: 'error',
                        autoDelete: true,
                        content: this.$t('mainPage.alerts.content.limitNotReset')
                    });
                }
                this.closeAwait = false;
            });
        },
        cancelPosition(item) {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function* () {
                item.closing = true;
                const response = yield this.services.v2.trade.cancelOrder({
                    orderId: item.id,
                    source: item.section === Sections.spot ? ServerSections.spot : ServerSections.futures,
                    ticker: item.ticker
                });
                const status = (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.payload) === null || _b === void 0 ? void 0 : _b.status;
                switch (status) {
                    case ItemClosingStatusEnum.closed: {
                        this.$store.dispatch('mainPageModules/setOrderClose', { by: ItemCloseRecordSource.wl, id: item.id });
                        this.$store.dispatch('alertsBus/openAlert', {
                            title: this.$t('mainPage.alerts.titles.success'),
                            type: 'success',
                            autoDelete: true,
                            content: this.$t('mainPage.alerts.content.limitApplicationReset')
                        });
                        break;
                    }
                    case ItemClosingStatusEnum.alreadyClosed: {
                        this.$store.dispatch('mainPageModules/setOrderClose', { by: ItemCloseRecordSource.wl, id: item.id });
                        break;
                    }
                    default: {
                        this.$store.dispatch('alertsBus/openAlert', {
                            title: this.$t('mainPage.alerts.titles.error'),
                            type: 'error',
                            autoDelete: true,
                            content: this.$t('mainPage.alerts.content.operationNotExecuted')
                        });
                    }
                }
                item.closing = false;
            });
        }
    },
    mounted() {
        const { thead, tbody } = this.$refs;
        function setSameWidth() {
            const tbodyCells = tbody.$el.querySelectorAll('tbody tr:first-of-type td');
            const theadCells = thead.$el.querySelectorAll('thead tr th');
            if (tbodyCells) {
                for (let i = 0; i < tbodyCells.length; i++) {
                    let width = theadCells[i].clientWidth;
                    if (width > 200)
                        width = 200;
                    theadCells[i].setAttribute('width', width);
                    tbodyCells[i].setAttribute('width', width);
                }
            }
        }
        if (window.innerWidth > 767) {
            setSameWidth();
            const tbodyObserver = new MutationObserver(setSameWidth);
            tbodyObserver.observe(thead.$el, {
                childList: true,
                subtree: true,
                characterData: true
            });
        }
    },
    beforeCreate() {
        const parsedHeads = localStorage.getItem('mainPageLimitBidsHeaders');
        if (parsedHeads)
            tableHeadItems = JSON.parse(parsedHeads);
    },
    components: {
        draggable,
        Swiper,
        swiperSlide,
        mobLimitBidsTableDetailItem
    },
    mixins: [selectHandlersMixin]
});
